// extracted by mini-css-extract-plugin
export default {"UserCircle":"Navbar_UserCircle__Mm-Oa","RecentOrdersButton":"Navbar_RecentOrdersButton__wmVJi","NavBar":"Navbar_NavBar__pPh-0"};